import { render, staticRenderFns } from "./InputPhone.vue?vue&type=template&id=160b157f&scoped=true&"
import script from "./InputPhone.vue?vue&type=script&lang=js&"
export * from "./InputPhone.vue?vue&type=script&lang=js&"
import style0 from "./InputPhone.vue?vue&type=style&index=0&id=160b157f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b157f",
  null
  
)

export default component.exports